module.exports = __webpack_public_path__ + "static/img/under_construction.3ef9356.jpg";